module.exports = __webpack_public_path__ + "77acd0f81cf5e8f80f26a72b96601b0b.pdf";